export enum personActionType {
  SET_REGISTER_PERSON_DATA = 'SET_REGISTER_PERSON_DATA',
  SET_REGISTER_BUSINESS_DATA = 'SET_REGISTER_BUSINESS_DATA',
  SET_PRODUCT_DATA = 'SET_PRODUCT_DATA',
  SET_FUNCTION_TYPE = 'SET_FUNCTION_TYPE',
  RESET_STATE = 'RESET_STATE',
}
